export enum WBPermissionType {
    NoAccess = 0,
    Read = 1,
    ReadWrite = 2,
    AllAccess = 3
}